// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"2d209806","136":"1268916d","265":"40a47f77","434":"27d4da88","787":"38ad8761"}[chunkId] + ".chunk.js";
};